export type EntityType = 
        | "SOCIETY" 
        | "BROKER"
        | "CONSTRUCTION_SITE" 
        | "CONSTRUCTION_SITE_SUBMISSION" 
        | "PARTNERSHIP_ANALYSIS" 
        | "PROPOSITION"
        | "CONTRACT"
        | "GFA";

export const getEntityNavigationUrl = (entityType: EntityType, entityId: string): string => {
        switch (entityType) {
                case "SOCIETY":
                case "BROKER":
                        return `/brokers/${entityId}?tab=documents`;
                case "CONSTRUCTION_SITE":
                        return `/projects/${entityId}?tab=documents`;
                case "CONSTRUCTION_SITE_SUBMISSION":
                        return `/projects/${entityId}?tab=documents`;
                case "PARTNERSHIP_ANALYSIS":
                        return `/partnerships/analysis/${entityId}?tab=documents`;
                case "CONTRACT":
                        return `/contracts/${entityId}?tab=documents`;
                case "PROPOSITION":
                        return `/proposals/${entityId}?tab=documents`;
                default:
                        throw new Error(`Type d'entité non géré: ${entityType}`);
        }
};

export const getEntityNavigationUrlForTasks = (entityType: EntityType, entityId: string): string => {
        switch (entityType) {
                case "SOCIETY":
                case "BROKER":
                        return `/brokers/${entityId}?tab=taches`;
                case "CONSTRUCTION_SITE":
                        return `/projects/${entityId}?tab=taches`;
                case "CONSTRUCTION_SITE_SUBMISSION":
                        return `/projects/${entityId}?tab=taches`;
                case "PARTNERSHIP_ANALYSIS":
                        return `/partnerships/analysis/${entityId}?tab=taches`;
                case "CONTRACT":
                        return `/contracts/${entityId}?tab=taches`;
                case "PROPOSITION":
                        return `/proposals/${entityId}?tab=taches`;
                default:
                        throw new Error(`Type d'entité non géré: ${entityType}`);
        }
};

export const getEntityFilterMatch = (entityType: EntityType, activeFilter: string, document?: { type?: string; isContract?: boolean }): boolean => {
        switch (activeFilter) {
                case "tous":
                        return true;
                case "apporteurs":
                        return entityType === "SOCIETY" || entityType === "BROKER";
                case "projets":
                        return entityType === "CONSTRUCTION_SITE" || entityType === "CONSTRUCTION_SITE_SUBMISSION";
                case "propositions":
                        return entityType === "PROPOSITION" && document?.isContract !== true;
                case "contrats":
                        return entityType === "PROPOSITION" && (document?.isContract === true);
                default:
                        return true;
        }
};
